@if (person) {
  <section id="person-detail-component" aria-labelledby="person-detail-heading" [attr.aria-busy]="saving">
    <header class="person-header">
      <div>
        <p class="eyebrow">Person details</p>
        <h2 id="person-detail-heading">{{person.name?.trim() || 'Name not provided'}}</h2>
      </div>
      @if (!editable && CanAdminister()) {
        <button #editButton type="button" class="person-button" (click)="setEditing()">
          <svg class="cms-icon" aria-hidden="true" focusable="false"><use href="/images/cms-actions.svg#edit"></use></svg>
          Edit person
        </button>
      }
    </header>
    <dl class="person-metadata contacts">
      <div><dt>Location</dt><dd>{{person.location?.trim() || 'Not provided'}}</dd></div>
      <div><dt>Email</dt><dd>
        @if (person.email?.trim()) { <a [href]="'mailto:' + person.email">{{person.email}}</a> }
        @else { <span class="missing">Not provided</span> }
      </dd></div>
      <div><dt>Phone</dt><dd>
        @if (person.phone?.trim()) { <a [href]="'tel:' + person.phone">{{person.phone}}</a> }
        @else { <span class="missing">Not provided</span> }
      </dd></div>
    </dl>
    <dl class="person-metadata record-details">
      <div><dt>Person ID</dt><dd>{{person.id}}</dd></div>
      <div><dt>GUID</dt><dd class="identifier">{{person.guid?.trim() || 'Not available in this view'}}</dd></div>
      <div><dt>Score</dt><dd>{{person.score ?? 'Not specified'}}</dd></div>
      <div><dt>Person type</dt><dd>{{personTypeDescription(person)}}</dd></div>
    </dl>
    @if (editable && personDraft) {
      <form (ngSubmit)="saveChanges()" aria-labelledby="person-edit-heading">
        <h3 id="person-edit-heading">Edit person</h3>
        <p class="field-hint" id="person-edit-help">Only person type can be changed here. Other details are read-only.</p>
        <div class="person-form-grid">
          <div class="form-field">
            <label for="person-type">Person type</label>
            <select #typeSelect id="person-type" name="person_type_id" [(ngModel)]="personDraft.person_type_id"
              [disabled]="saving" aria-describedby="person-edit-help">
              @if (person.person_type_id !== 1 && person.person_type_id !== 2) {
                <option [ngValue]="person.person_type_id" disabled>{{personTypeDescription(person)}}</option>
              }
              @for (personType of personTypes; track personType.person_type_id) {
                <option [ngValue]="personType.person_type_id">{{personType.person_type_description}}</option>
              }
            </select>
          </div>
        </div>
        <footer class="form-actions">
          <button type="button" class="person-button" (click)="cancelChanges()" [disabled]="saving">
            <svg class="cms-icon" aria-hidden="true" focusable="false"><use href="/images/cms-actions.svg#close"></use></svg>
            Cancel
          </button>
          <button type="submit" class="person-button primary" [disabled]="saving || personDraft.person_type_id === person.person_type_id">
            {{saving ? 'Saving...' : 'Save'}}
          </button>
        </footer>
      </form>
    }
    @if (saveMessage) { <p class="save-status" role="status">{{saveMessage}}</p> }
    @if (errorMessage) { <p class="error-status" role="alert">{{errorMessage}}</p> }
  </section>
  <h2 class="responses-heading">Responses <span class="response-count">({{person.response_count ?? 0}})</span></h2>
} @else if (errorMessage) {
  <p class="error-status" role="alert">{{errorMessage}}</p>
} @else {
  <p role="status">Loading person details...</p>
}
